module.exports = __webpack_public_path__ + "static/img/shuiku2.d1a74aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/experienceContentImg/shuiku2.png
// module id = DiuT
// module chunks = 1